import "./Support.module.css";
import NavigationPortal from "@/reusable_sections/Header";
import TechnicalSpecsDownloads from "./sections/TechnicalSpecsDownloads";
import QuickTips from "./sections/QuickTips";
import Footer from "@/reusable_sections/Footer";
export default function SupportPage() {
  return <div>
      <NavigationPortal />
      <TechnicalSpecsDownloads />
      <QuickTips />
      <Footer />
    </div>;
}